@if (!(layoutService.fullHeight$ | async)) {
  <sandoz-header />
}

<mat-sidenav-container [class.full-height]="layoutService.fullHeight$ | async">
  <mat-sidenav-content>
    <router-outlet />
  </mat-sidenav-content>

  <mat-sidenav class="sidenav" position="start" mode="over" #sidenavLeft>
    <sandoz-sidebar sidebarId="left" [container]="sidenavLeft" />
  </mat-sidenav>

  <mat-sidenav class="sidenav" position="end" mode="over" #sidenavRight>
    <sandoz-sidebar sidebarId="right" [container]="sidenavRight" />
  </mat-sidenav>
</mat-sidenav-container>

@if ($isLocalhost() || (sessionRepo.isDeveloper$ | async)) {
  <sandoz-dev-settings />
}

<!-- For google analytics -->
@if (sessionRepo.isLoggedIn$ | async) {
  @if ((sessionRepo.authUser$ | async)?.country; as userCountry) {
    <div
      style="visibility: hidden; width: 0px; height: 0px"
      [attr.data-user-country]="userCountry.name"
    ></div>
  }
}
